import { mathjax } from 'mathjax-full/js/mathjax.js'
import { TeX } from 'mathjax-full/js/input/tex.js'
import { SVG } from 'mathjax-full/js/output/svg.js'
import { liteAdaptor } from 'mathjax-full/js/adaptors/liteAdaptor.js'
import { RegisterHTMLHandler } from 'mathjax-full/js/handlers/html.js'
import { AllPackages } from 'mathjax-full/js/input/tex/AllPackages.js'

let mathjaxDoc: any = null
let adaptor: any = null
let initialized = false

export function initMathjax(): void {
  if (initialized) return

  adaptor = liteAdaptor()
  RegisterHTMLHandler(adaptor)
  const tex = new TeX({ packages: AllPackages })
  const svg = new SVG({ fontCache: 'local' })
  mathjaxDoc = mathjax.document('', { InputJax: tex, OutputJax: svg })
  initialized = true
}

export function renderMath(tex: string, displayMode: boolean): string {
  initMathjax()

  if (!mathjaxDoc || !adaptor) {
    return `<span class="mathjax-error">${escapeHtml(tex)}</span>`
  }

  try {
    const node = mathjaxDoc.convert(tex, { display: displayMode })
    return adaptor.outerHTML(node)
  } catch (error) {
    const msg = error instanceof Error ? error.message : 'MathJax render error'
    return `<span class="mathjax-error" title="${escapeHtml(msg)}">${escapeHtml(tex)}</span>`
  }
}

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}
